import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import client from '@/api/client';
import type { Hostel } from '@/api/types';
import { useTenantPortalGuard, HostelSelector } from './tenantPortalShared';

export function TenantRulesPage() {
  const { t } = useTranslation();
  const portal = useTenantPortalGuard();

  const { data: hostelInfo } = useQuery<Hostel | null>({
    queryKey: ['tenant-portal-hostel-rules'],
    queryFn: () => client.get('/api/tenant-portal/hostel-rules').then(r => r as unknown as Hostel | null),
    enabled: !('guard' in portal),
  });

  if ('guard' in portal) return portal.guard;
  const { activeTenants, tenantIdx, setSelectedTenantIdx } = portal;

  return (
    <div className="max-w-3xl mx-auto space-y-4">
      <h1 className="text-2xl font-bold text-gray-900">{t('hostel.rules', 'Rules & Terms')}</h1>

      <HostelSelector activeTenants={activeTenants} tenantIdx={tenantIdx} onChange={setSelectedTenantIdx} />

      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        {hostelInfo?.rules ? (
          <pre className="text-sm text-gray-700 whitespace-pre-wrap font-sans leading-relaxed bg-amber-50 border border-amber-100 rounded-xl p-4">
            {hostelInfo.rules}
          </pre>
        ) : (
          <p className="text-sm text-gray-400 italic bg-gray-50 rounded-xl p-4">{t('tenant.noRulesSet', 'No specific rules have been set by this hostel yet.')}</p>
        )}
      </div>
    </div>
  );
}
